import { z } from "zod";
export const SurveyOptionsSchema = z.array(z.object({
    id: z.string(),
    title: z.string()
}));
export const SurveyEditSchema = z.object({
    id: z.number(),
    applicationId: z.number(),
    name: z.string(),
    title: z.string(),
    message: z.string(),
    options: SurveyOptionsSchema,
    includeOtherOption: z.boolean().optional(),
    includeCloseOption: z.boolean().optional(),
    presentationProbability: z.number().min(0).max(1).optional()
});
export const CreateSurveySchema = SurveyEditSchema.omit({
    id: true
});
// Require id, but make everything else optional
export const UpdateSurveySchema = SurveyEditSchema.omit({
    id: true,
    applicationId: true
}).partial().extend({
    id: z.number()
});
